import { mode, transparentize } from '@chakra-ui/theme-tools';
const parts = ['item', 'command', 'list', 'button', 'groupTitle', 'divider'];
const baseStyleList = (props) => {
    return {
        bg: mode('white', 'gray.550')(props),
        boxShadow: mode('sm', 'dark-lg')(props),
        color: 'inherit',
        py: '4px',
        zIndex: 1,
        borderRadius: 'base',
        borderWidth: '1px',
    };
};
const baseStyleItem = (props) => {
    return {
        transition: 'background 50ms ease-in 0s',
        _focus: {
            bg: mode('blue.500', 'blue.400')(props),
            color: mode('white', 'black')(props),
        },
        _active: {
            bg: mode('blue.500', 'blue.400')(props),
            color: mode('white', 'black')(props),
        },
        _expanded: {
            bg: mode('blue.500', 'blue.400')(props),
            color: mode('white', 'black')(props),
        },
        _disabled: {
            opacity: 0.4,
            cursor: 'not-allowed',
        },
    };
};
const baseStyleGroupTitle = {
    mx: '16px',
    my: '12px',
    fontWeight: 'semibold',
    fontSize: '12px',
};
const baseStyleCommand = {
    opacity: 0.6,
};
const getBaseStyleDivider = (props) => {
    return {
        border: 0,
        borderBottom: '1px solid',
        borderBottomColor: mode(transparentize('gray.500', 0.24), transparentize('white', 0.06))(props),
    };
};
const sizes = {
    md: {
        item: {
            height: '36px',
            px: '16px',
            fontSize: 'md',
        },
        list: {
            maxW: 'lg',
            minW: '2xs',
        },
        divider: {
            my: 2,
        },
    },
    sm: {
        item: {
            height: '24px',
            px: '16px',
            fontSize: 'sm',
        },
        list: {
            minW: '3xs',
            maxW: 'sm',
        },
        divider: {
            my: 1,
        },
    },
};
const baseStyle = (props) => ({
    list: baseStyleList(props),
    item: baseStyleItem(props),
    divider: getBaseStyleDivider(props),
    groupTitle: baseStyleGroupTitle,
    command: baseStyleCommand,
});
const defaultProps = {
    size: 'md',
};
export default {
    parts,
    baseStyle,
    defaultProps,
    sizes,
};
//# sourceMappingURL=menu.js.map